





























import HeaderItem from "@/components/HeaderItem.vue";
import Page from "@/components/Page.vue";
// import InvoiceRejectionForm from "@/components/InvoiceRejectionForm.vue";
import Vue from "vue";
import { store, TechnicalInvoiceStore } from "../services/TechnicalInvoiceStore";
import TechnicalInvoiceView from "./TechnicalInvoiceView.vue";
import { t } from "@/plugins/i18n";
// import TechnicalInvoiceVIRIDisplayView from "./TechnicalInvoiceVIRIDisplayView.vue";

interface Data {
  store: TechnicalInvoiceStore;
}

interface Computed {
  technicalInvoiceTitle: string;
}

export default Vue.extend<Data, {}, Computed>({
  components: { Page, HeaderItem, TechnicalInvoiceView },
  data() {
    return {
      store: store,
    };
  },

  created() {
    this.store.autoViriCreation = false;
  },

  computed: {
    technicalInvoiceTitle() {
      if (this.$route.params.codeFilter === "viro") {
        return t("TechnicalInvoice_KimenoTechnikaiSzamlaAdatokVIRO");
      }
      if (this.$route.params.codeFilter === "viri") {
        return t("TechnicalInvoice_BejovoTechnikaiSzamlaAdatokVIRI");
      }
      throw new Error(t("TechnicalInvoice_InvalidPrefix"));
    },
  },
});
